var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticClass:"header-bar-container"},[_c('i-col',{staticClass:"header-col",attrs:{"span":"24"}},[_c('div',{staticClass:"header-left"},[_vm._t("left")],2),_c('div',{staticClass:"header-right"},[_vm._t("right")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }